import toast from 'react-hot-toast';
import { MapRefs } from './types';
import { updateMarkerPosition } from './mapUtils';

export const handleSearch = async (
  searchQuery: string,
  refs: MapRefs,
  setCoordinates: (coords: string) => void,
  onClick?: (lat: number, lng: number) => void
) => {
  if (!refs.mapInstanceRef.current || !searchQuery.trim()) return;

  try {
    const results = await window.ymaps.geocode(searchQuery);
    const firstGeoObject = results.geoObjects.get(0);
    
    if (firstGeoObject) {
      const coords = firstGeoObject.geometry.getCoordinates();
      refs.mapInstanceRef.current.setCenter(coords);
      refs.mapInstanceRef.current.setZoom(14);
      
      if (onClick) {
        onClick(coords[0], coords[1]);
        setCoordinates(`${coords[0]}, ${coords[1]}`);
        updateMarkerPosition(coords, refs, onClick);
      }
    }
  } catch (error) {
    console.error('Geocoding error:', error);
    toast.error('Не атрымалася знайсці месца');
  }
};

export const handleCoordinatesSubmit = (
  coordinates: string,
  refs: MapRefs,
  onClick?: (lat: number, lng: number) => void
) => {
  const [lat, lng] = coordinates.split(',').map(coord => parseFloat(coord.trim()));
  if (!isNaN(lat) && !isNaN(lng)) {
    if (onClick) {
      onClick(lat, lng);
    }
    updateMarkerPosition([lat, lng], refs, onClick);
    refs.mapInstanceRef.current?.setCenter([lat, lng]);
    refs.mapInstanceRef.current?.setZoom(14);
  }
};